import clsx from 'clsx';
import type { IconProps } from '../components/types.js';
import { fgTone } from '../utils/style/tone.js';
const displayName = 'IconCategoryNewspaper';
/** Renders an SVG icon. */
const SvgCategoryNewspaper = ({
  size,
  'aria-hidden': ariaHidden,
  tone,
  UNSAFE_className,
  UNSAFE_style,
  ...rest
}: IconProps) => {
  const props = {
    ...rest,
    'aria-hidden': ariaHidden ?? (rest['aria-label'] == null && rest['aria-labelledby'] == null),
    className: clsx('cim-icon', tone && fgTone(tone), UNSAFE_className),
    style: UNSAFE_style,
    width: size != null ? size + 'px' : '1em',
    height: size != null ? size + 'px' : '1em',
  };
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32" data-icon="true" fill="currentColor" {...props}>
      <path
        fill="currentColor"
        fillRule="evenodd"
        d="M8 6a2 2 0 0 1 2-2h16a2 2 0 0 1 2 2v19a5 5 0 0 1-5 5H7a3 3 0 0 1-3-3V12a1 1 0 0 1 1-1h3zm0 7H6v14a1 1 0 1 0 2 0zm1.83 15H23a3 3 0 0 0 3-3V6H10v21c0 .35-.06.687-.17 1M12 17a1 1 0 0 1 1-1h3a1 1 0 1 1 0 2h-3a1 1 0 0 1-1-1m7 1a2 2 0 0 1 2-2h2a2 2 0 0 1 2 2v2a2 2 0 0 1-2 2h-2a2 2 0 0 1-2-2zm4 0h-2v2h2zm-11 3a1 1 0 0 1 1-1h2a1 1 0 1 1 0 2h-2a1 1 0 0 1-1-1m0 4a1 1 0 0 1 1-1h8a1 1 0 1 1 0 2h-8a1 1 0 0 1-1-1"
      />
      <path
        fill="currentColor"
        fillRule="evenodd"
        d="M17.385 7.503a.75.75 0 0 1-.064 1.059L15.13 10.5l2.19 1.938a.75.75 0 0 1-.995 1.123l-2.823-2.5a.75.75 0 0 1 0-1.123l2.823-2.5a.75.75 0 0 1 1.06.065m2.585.967a.75.75 0 0 1 1.06 0l1.5 1.5a.75.75 0 0 1 0 1.06l-1.5 1.5a.75.75 0 1 1-1.06-1.06l.97-.97-.97-.97a.75.75 0 0 1 0-1.06"
      />
      <path
        fill="currentColor"
        d="m18.604 11.646.792-.792a.5.5 0 0 0 0-.708l-.792-.792a.5.5 0 0 0-.708 0l-.792.792a.5.5 0 0 0 0 .708l.792.792a.5.5 0 0 0 .708 0"
      />
    </svg>
  );
};
SvgCategoryNewspaper.displayName = displayName;
export default SvgCategoryNewspaper;
